import { SystemMaintenanceEventSearchRequestQuery } from '@lio/api-types';

export const systemManagementKeys = {
  events: ['events'] as const,
  _search: () => [...systemManagementKeys.events, 'list'],
  eventsSearch: ({ pageLimit, pageOffset, ...filters }: SystemMaintenanceEventSearchRequestQuery) =>
    [...systemManagementKeys._search(), filters, { pageLimit, pageOffset }] as const,
  getEvent: (id: string) => [...systemManagementKeys.events, id] as const,
};
